import { render, staticRenderFns } from "./DataTriangulationDashboard.vue?vue&type=template&id=4ea90b25&scoped=true"
import script from "./DataTriangulationDashboard.vue?vue&type=script&lang=js"
export * from "./DataTriangulationDashboard.vue?vue&type=script&lang=js"
import style0 from "./DataTriangulationDashboard.vue?vue&type=style&index=0&id=4ea90b25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea90b25",
  null
  
)

export default component.exports